export const queryKeys = {
  DTM_BLOCKS: 'dmt-blocks',
  DTM_COLLECTIONS: 'dmt-collections'
};
